// extracted by mini-css-extract-plugin
export default {"addButtonDescription":"AddAttachmentListItem_addButtonDescription__NAaQQ"};